<template>
    <q-card>
        <q-card-section>
            <div class="text-h6">盤點</div>
        </q-card-section>

        <q-card-section>
            <div class="row q-gutter-sm q-mb-sm">
                <div class="col">
                    <q-input v-model="productSelectStock.Title" readonly label="所選庫位名稱" />
                </div>
                <div class="col">
                    <q-input v-model="productSelectStock.Stock" readonly label="所選庫位數量" />
                </div>
            </div>
            <div class="row q-gutter-sm">
                <div class="col col-12">
                    <q-input v-model="move.stock" label="調整數量" />
                </div>
                <div class="col col-12">
                    <q-input v-model="move.note" label="備註" hint="備註限定50字內" />
                </div>
            </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
            <q-btn color="green" label="送出" @click="productPutStockModify(move)"/>
            <q-btn color="blue" label="關閉" v-close-popup />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: "StockModify",
    data() {
        return {
            move: {
                blockID: "",
                beforeStock: "",
                stock: "",
                note: ""
            }
        }
    },
    created() {
        this.move.blockID = this.productSelectStock.ID
        this.move.beforeStock = this.productSelectStock.Stock
    },
    computed: {
      ...mapGetters(['productSelectStock', 'productDetail'])
    },
    methods: {
        ...mapActions(['productPutStockModify'])
    }
}
</script>